import { ColDef } from "ag-grid-community";

export const cellClassName = "centered-cell";

/**
 * Shared AG Grid locale overrides for the columns tool panel and reset-columns action.
 * Pass to `<AgGridReact localeText={...} />` (or merge into `gridOptions`) in each grid that
 * needs these label overrides.
 */
export const gridLocaleText: Record<string, string> = {
  columnChooser: "Show/Hide Column Display",
  resetColumns: "Reset Column Display",
};

export const defaultColDef: ColDef = {
  wrapHeaderText: true,
  autoHeaderHeight: true,
  suppressMovable: true,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  cellClass: cellClassName,
  autoHeight: true,
  wrapText: true,
  cellStyle: {
    lineHeight: 2,
  },
};

/**
 * Column builder for AG Grid
 */
export function buildColumnDefs<
  TRow,
  TMap extends Record<string, ColDef<TRow>>,
  TKeys extends readonly (keyof TMap)[],
>(
  allColumns: TMap,
  keys: TKeys,
  overrides?: Partial<ColDef<TRow>>,
): ColDef<TRow>[] {
  return keys.map((key) => ({
    ...defaultColDef,
    ...allColumns[key],
    ...overrides,
  }));
}
